var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.88,
    height: 56.188,
    viewBox: "0 0 41.88 56.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffe4a5}.cls-2{fill:#ffcf5d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical-file",
    transform: "translate(-65.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    transform: "translate(65.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1780",
    d: "M4 0h31a4 4 0 0 1 4 4v44H0V4a4 4 0 0 1 4-4z",
    className: "cls-1",
    transform: "translate(1.263 6.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1781",
    d: "M4 0h1a4 4 0 0 1 4 4v7H0V4a4 4 0 0 1 4-4z",
    className: "cls-1",
    transform: "translate(16.263 .832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    d: "M103.115 6.426h-7.652v-.71a1.1 1.1 0 0 0-1.1-1.1h-3.604a4.628 4.628 0 0 0-9.256 0H77.9a1.1 1.1 0 0 0-1.1 1.1v.71h-7.654a3.96 3.96 0 0 0-3.955 3.955v41.852c0 1.082 0 3.955 2.858 3.955h35.066a3.96 3.96 0 0 0 3.955-3.955V10.381a3.96 3.96 0 0 0-3.955-3.955zm-24.121.388h3.777a1.1 1.1 0 0 0 1.044-1.435 2.433 2.433 0 1 1 4.631 0 1.1 1.1 0 0 0 1.044 1.435h3.777v4.441H78.994zm25.882 45.42a1.763 1.763 0 0 1-1.761 1.761H68.049c-.382 0-.427-.1-.479-.206a4.42 4.42 0 0 1-.184-1.555V10.381a1.763 1.763 0 0 1 1.761-1.761H76.8v2.634h-5.683a1.1 1.1 0 0 0-1.1 1.1v37.91a1.1 1.1 0 0 0 1.1 1.1h30.028a1.1 1.1 0 0 0 1.1-1.1V36.971a1.1 1.1 0 1 0-2.195 0v12.194H72.215V13.449h27.833v13.6a1.1 1.1 0 1 0 2.195 0v-14.7a1.1 1.1 0 0 0-1.1-1.1h-5.68V8.621h7.653a1.763 1.763 0 0 1 1.76 1.761v41.851z",
    className: "cls-2",
    transform: "translate(-65.191)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779",
    width: 34,
    height: 41,
    className: "cls-1",
    rx: 2,
    transform: "translate(4.263 10.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    d: "M172.083 148.742a6.759 6.759 0 0 0-4.534-1.914 7.676 7.676 0 0 0-4.743 1.824 7.857 7.857 0 0 0-4.714-1.824 6.973 6.973 0 0 0-5.335 2.8 6.87 6.87 0 0 0-1.189 2.351l-.027.1a6.264 6.264 0 0 0-.2 1.282 8.071 8.071 0 0 0 .111 1.809 8.685 8.685 0 0 0 1.138 2.959c.839 1.425 3.485 3.641 6.6 6.178.633.516 1.231 1 1.684 1.386a2.986 2.986 0 0 0 3.872 0c.457-.387 1.061-.879 1.7-1.4 3.117-2.537 5.765-4.753 6.6-6.165a9.518 9.518 0 0 0 .868-1.88 7.9 7.9 0 0 0 .381-2.889 6.809 6.809 0 0 0-2.214-4.616zm-18.546 4.721a4.075 4.075 0 0 1 .129-.833l.018-.065a4.689 4.689 0 0 1 .814-1.6 4.808 4.808 0 0 1 3.6-1.942 6 6 0 0 1 3.571 1.53 1.777 1.777 0 0 0 2.318-.021 5.634 5.634 0 0 1 3.568-1.509 4.915 4.915 0 0 1 4.555 4.44 5.809 5.809 0 0 1-.163 1.713h-2.097l-.935-2.066a1.1 1.1 0 0 0-1.994-.013l-1.424 3.042-.734-1.441a1.1 1.1 0 0 0-1.981.054l-.971 2.19-1.679-4.654a1.1 1.1 0 0 0-1.888-.314l-2.737 3.413h-1.748a5.543 5.543 0 0 1-.141-.6 5.919 5.919 0 0 1-.081-1.324zm11.526 9.126c-.648.528-1.261 1.026-1.733 1.426a.8.8 0 0 1-1.035 0c-.469-.4-1.074-.891-1.716-1.413a56.418 56.418 0 0 1-5.668-5.02h1.122a1.1 1.1 0 0 0 .856-.411l1.842-2.3 1.942 5.384a1.1 1.1 0 0 0 .993.724h.039a1.1 1.1 0 0 0 1-.653l1.145-2.582.707 1.387a1.1 1.1 0 0 0 1.972-.033l1.366-2.916.244.539a1.1 1.1 0 0 0 1 .645h1.761a50.8 50.8 0 0 1-5.841 5.218z",
    className: "cls-2",
    transform: "translate(-141.881 -130.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    d: "M178.266 352.234H158.91a1.1 1.1 0 1 0 0 2.195h19.356a1.1 1.1 0 1 0 0-2.195z",
    className: "cls-2",
    transform: "translate(-147.648 -313.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    d: "M178.266 392.234H158.91a1.1 1.1 0 1 0 0 2.195h19.356a1.1 1.1 0 1 0 0-2.195z",
    className: "cls-2",
    transform: "translate(-147.648 -349.189)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalfile);
export default __webpack_public_path__ + "static/media/medicalfile.64bbc4795600292db87c4acad9b26821.svg";
export { ForwardRef as ReactComponent };